import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { BackOfficeContext } from "../BackOffice";
import ClassTypesDropdown from "../../../components/dropdowns/ClassTypesDropdown";
import { Checkbox } from "semantic-ui-react";
import { validatePrice } from "../../../commonData";

const AddEditPass = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const { setPassesList } = useContext(BackOfficeContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [pass, setPass] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (pass.pass_name.length === 0 || !pass.pass_name.replace(/\s+/, "")) {
            $("#passName").addClass("is-invalid");
            errors.push(t("error.noPassName"));
        }
        if (!validatePrice(pass.pass_price)) {
            $("#passPrice").addClass("is-invalid");
            errors.push(t("error.noPassPrice"));
        }
        if (pass.pass_duration_days.length === 0) {
            $("#passDuration").addClass("is-invalid");
            errors.push(t("error.noPassDuration"));
        } else if (pass.pass_duration_days.length > 11 || pass.pass_duration_days === 0 || pass.pass_duration_days === "0") {
            $("#passDuration").addClass("is-invalid");
            errors.push(t("error.invalidPassDuration"));
        }
        if (pass.pass_entries.length === 0) {
            $("#passEntires").addClass("is-invalid");
            errors.push(t("error.noPassEntries"));
        } else if (pass.pass_entries.length > 11 || pass.pass_entries === 0 || pass.pass_entries === "0") {
            $("#passEntires").addClass("is-invalid");
            errors.push(t("error.invalidPassEntries"));
        }
        if (pass.pass_quantity.length > 0) {
            if (pass.pass_quantity.length > 11) {
                $("#passQuantity").addClass("is-invalid");
                errors.push(t("error.invalidPassQuantity"));
            } else if (pass.pass_quantity === 0 || pass.pass_quantity === "0") {
                $("#passQuantity").addClass("is-invalid");
                errors.push(t("error.passQuantityCannotBe0"));
            }
        }

        if (pass.pass_user_limit.length > 0) {
            if (pass.pass_user_limit.length > 11) {
                $("#passUserLimit").addClass("is-invalid");
                errors.push(t("error.invalidPassUserLimit"));
            } else if (pass.pass_user_limit === 0 || pass.pass_user_limit === "0") {
                $("#passUserLimit").addClass("is-invalid");
                errors.push(t("error.passUserLimitCannotBe0"));
            }
        }

        if (pass.pass_descr.length > 0 && pass.pass_descr.length > 255) {
            $("#passDescription").addClass("is-invalid");
            errors.push(t("error.passDescriptionTooLong"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e, i) => {
                list.push({ variant: "danger", message: e, id: i });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t(`info.${showView.params.passID ? "updatingPass" : "creatingPass"}`) }]);
            setBlockForm(true);
            addEditPass();
        }
    };

    const addEditPass = async () => {
        const res = await postMethod("/create-edit-pass", {
            pass: pass,
            passID: showView.params.passID,
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "addedPass" }]);
            setPassesList(null);
            changeView({ nav: "passes", sub: "passesList" });
        } else setBlockForm(false);
    };

    const autoResize = (textarea) => {
        textarea.style.height = "auto"; // Resetowanie wysokości
        textarea.style.height = `${textarea.scrollHeight}px`; // Ustawienie wysokości na podstawie zawartości
    };

    useEffect(() => {
        if (!loading) {
            const textarea = document.getElementById("passDescription");
            autoResize(textarea);
            textarea.addEventListener("input", function () {
                autoResize(this);
            });
        }
        // eslint-disable-next-line
    }, [loading]);

    useEffect(() => {
        if (pass) {
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [pass]);

    const getPassData = async () => {
        const res = await postMethod("/get-pass-data", { passID: showView.params.passID });
        if (checkServerData(res)) {
            setPass(res.data.pass);
            setLoading(false);
        }
    };

    const getGlobalSettings = async () => {
        const res = await postMethod("/get-global-settings");
        if (checkServerData(res)) {
            if (!showView.params.passID) {
                setPass({
                    pass_name: "",
                    pass_descr: "",
                    pass_duration_days: res.data.settings.filter((e) => e.setting_code === "PASS_DURATION")[0].setting_value_int,
                    pass_price: "",
                    pass_entries: "",
                    pass_quantity: "",
                    pass_active: true,
                    pass_visible: true,
                    pass_type: [],
                    pass_user_limit: "",
                });
                setLoading(false);
            } else getPassData();
        }
    };

    useEffect(() => {
        $(`#list`).css("min-height", `${window.innerHeight - $("#goBackBtn").outerHeight() - $("#footerMain").outerHeight()}px`);
        getGlobalSettings();

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Container fluid="lg" id="addEditPass">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t(`passes.${showView.params.passID ? "edit" : "createNew"}Pass`)}</h1>
                    </Col>
                    {loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="w-100">
                                                {t(`passes.passName`)} <span className="req">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                value={pass.pass_name}
                                                placeholder={t("passes.typePassName")}
                                                onChange={(e) => {
                                                    setPass({ ...pass, pass_name: e.target.value });
                                                    setFormChanged(true);
                                                    $("#passName").removeClass("is-invalid");
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3">
                                            <ClassTypesDropdown
                                                onChange={(v) => {
                                                    setPass({ ...pass, pass_type: v });
                                                    $("#passType").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                value={pass.pass_type}
                                                multiple
                                                req
                                                id="passType"
                                                disabled={blockForm}
                                                label={t("passes.assignToClassTypes")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} lg={3}>
                                        <Form.Group className="mb-3" controlId={`passEntries`}>
                                            <Form.Label className="w-100">
                                                {t(`passes.passEntries`)} <span className="req">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={pass.pass_entries}
                                                onChange={(el) => {
                                                    setPass({ ...pass, pass_entries: el.target.value });
                                                    $("#passEntries").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                placeholder={t(`typeNumber`)}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} lg={3}>
                                        <Form.Group className="mb-3" controlId={`passPrice`}>
                                            <Form.Label className="w-100">
                                                {t(`passes.passPrice`)} <span className="req">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={pass.pass_price}
                                                onChange={(el) => {
                                                    setPass({ ...pass, pass_price: el.target.value });
                                                    $("#passPrice").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                placeholder={t(`typeNumber`)}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={9} lg={6}>
                                        <Form.Group className="mb-3" controlId={`passDuration`}>
                                            <Form.Label className="w-100">
                                                {t(`passes.passDurationFromBuyDate`)} <span className="req">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={pass.pass_duration_days}
                                                onChange={(el) => {
                                                    setPass({ ...pass, pass_duration_days: el.target.value });
                                                    $("#passDuration").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                placeholder={t(`typeNumber`)}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`passQuantity`}>
                                            <Form.Label className="w-100 mb-1">{t(`passes.passQuantity`)}</Form.Label>
                                            <p className="text-small mb-2">{t(`passes.passQuantityHelper`)}</p>
                                            <Form.Control
                                                type="number"
                                                value={pass.pass_quantity}
                                                onChange={(el) => {
                                                    setPass({ ...pass, pass_quantity: el.target.value });
                                                    $("#passQuantity").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                placeholder={t(`typeNumber`)}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`passUserLimit`}>
                                            <Form.Label className="w-100 mb-1">{t(`passes.passUserLimit`)}</Form.Label>
                                            <p className="text-small mb-2">{t(`passes.passUserLimitHelper`)}</p>
                                            <Form.Control
                                                type="number"
                                                value={pass.pass_user_limit}
                                                onChange={(el) => {
                                                    setPass({ ...pass, pass_user_limit: el.target.value });
                                                    $("#passUserLimit").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                placeholder={t(`typeNumber`)}
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`passDescription`}>
                                            <Form.Label className="w-100">{t(`passes.passDescription`)}</Form.Label>
                                            <Form.Control
                                                value={pass.pass_descr}
                                                onChange={(el) => {
                                                    setPass({ ...pass, pass_descr: el.target.value });
                                                    $("#passDescription").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                                placeholder={t(`passes.passDescriptionPlaceholder`)}
                                                as="textarea"
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`passActive`}>
                                            <Checkbox
                                                toggle
                                                label={t("passes.passIsActive")}
                                                checked={pass.pass_active}
                                                disabled={blockForm}
                                                onChange={() => {
                                                    setPass({ ...pass, pass_active: !pass.pass_active });
                                                    $("#passActive").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className="mb-3" controlId={`passVisible`}>
                                            <Checkbox
                                                toggle
                                                label={t("passes.passIsVisible")}
                                                checked={pass.pass_visible}
                                                disabled={blockForm}
                                                onChange={() => {
                                                    setPass({ ...pass, pass_visible: !pass.pass_visible });
                                                    $("#passVisible").removeClass("is-invalid");
                                                    setFormChanged(true);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 1 }}>
                                    <Col xs={12} className="my-4">
                                        <Row>
                                            <Col xs={7} lg={6}>
                                                <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                                                    {t(`passes.${showView.params.passID ? "update" : "add"}Pass`)}
                                                </Button>
                                            </Col>
                                            <Col xs={5} lg={6} className="text-end">
                                                <Button variant="outline-secondary" onClick={() => changeView({ nav: "passes", sub: "passesList" })}>
                                                    {t("cancel")}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default AddEditPass;
